module.exports = __webpack_public_path__ + "d688fdf40e48b67dce987a4ed7a5a53c.svg";